var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgebaseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\bavoassistant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 3463457"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_291_7089",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 25,
    width: 40,
    height: 20,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 25,
    width: 40,
    height: 20,
    rx: 1,
    fill: "white",
    stroke: "#23C29D",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_291_7089)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3463370",
    d: "M26.5 16L42.5 16V39.6453C42.5 39.6467 42.4999 39.6477 42.4999 39.6483C42.4992 39.6494 42.4968 39.6528 42.4916 39.6567C42.4856 39.6612 42.4794 39.6637 42.475 39.6646C42.473 39.665 42.4712 39.6651 42.4696 39.6651C42.4681 39.665 42.4653 39.6648 42.4609 39.6636C40.6269 39.1667 37.0918 38.3043 34.5 38.3043C31.9082 38.3043 28.3731 39.1667 26.5391 39.6636C26.5347 39.6648 26.5319 39.665 26.5304 39.6651C26.5296 39.6651 26.5288 39.6651 26.528 39.665C26.5271 39.6649 26.5261 39.6648 26.525 39.6646C26.5206 39.6637 26.5144 39.6612 26.5084 39.6567C26.5032 39.6528 26.5008 39.6494 26.5001 39.6483C26.5001 39.6477 26.5 39.6467 26.5 39.6453V16Z",
    fill: "white",
    stroke: "#23C29D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463447",
    x: 29.5,
    y: 21,
    width: 10,
    height: 1.53847,
    fill: "#23C29D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463449",
    x: 29.5,
    y: 26,
    width: 8,
    height: 1.53847,
    fill: "#23C29D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3463452",
    d: "M26.5 16L10.5 16V39.6049C10.5 39.6081 10.5003 39.6089 10.5002 39.6083C10.5001 39.6078 10.4999 39.6077 10.5002 39.6081C10.5008 39.6093 10.5041 39.6146 10.5124 39.6207C10.5207 39.6268 10.5297 39.6305 10.5371 39.6319C10.543 39.633 10.549 39.6332 10.5578 39.6306C12.3282 39.125 15.6285 38.3043 18.5 38.3043C21.3715 38.3043 24.6718 39.125 26.4422 39.6306C26.451 39.6332 26.457 39.633 26.4629 39.6319C26.4703 39.6305 26.4793 39.6268 26.4876 39.6207L26.5 16ZM26.5 16V39.6049M26.5 16V39.6049M26.5 39.6049C26.5 39.6066 26.4999 39.6076 26.4998 39.6081L26.5 39.6049Z",
    fill: "white",
    stroke: "#23C29D",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463453",
    x: 13.5,
    y: 21,
    width: 10,
    height: 1.53847,
    fill: "#23C29D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463454",
    x: 13.5,
    y: 26,
    width: 10,
    height: 1.53847,
    fill: "#23C29D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463455",
    x: 13.5,
    y: 31,
    width: 10,
    height: 1.53847,
    fill: "#23C29D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgebaseGreen);
export default __webpack_public_path__ + "static/media/knowledgebase-green.d8729ee962e4cebe9248b0e5663c01ce.svg";
export { ForwardRef as ReactComponent };